/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { SETTINGS_ROUTE } from "../../constants/routes.js";

/* Components */
import { ReactComponent as ArrowForward } from "../../resources/images/arrow-right-carousel.svg";
import UCButton from "../buttons";

/* Styles */
import styles from "./styles.js";

const messages = {
  "COMPANY_PROFILE_INCOMPLETE": "incomplete.company.banner.text"
}

const ProfileIncompleteBanner = ({ bannerResponse }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const navigate = useNavigate();

  return (
    <div className={classes.mainWrapper}>
      <div className={classes.incompleteWrapper}>
        <p className={classes.incompleteText}>
          {bannerResponse?.bannerMessages?.map(key => {
            return <FormattedMessage key={key} id={messages[key]} />
          })}
        </p>
        <UCButton
          type="default"
          className={classes.btn}
          text={<FormattedMessage id="incomplete.btn.text" />}
          icon={<ArrowForward />}
          onClick={() => navigate("../" + SETTINGS_ROUTE)}
        />
      </div>
    </div>
  );
};

export default ProfileIncompleteBanner;
